import { LightTable } from "../system/table";

export class InstitutionInformation {
  sourceInstitutionTable: LightTable;
  destinationInstitutionTable: LightTable;
  allInstitutionTable: LightTable;
}
